import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { palette } from '../../../../assets/styles/themes/tokens';
import { routes } from '../../../../constants';
import CardDescription from '../../common/CardDescription/NewCardDescription';
import { AddMenuButton, Metadata } from '../MuiCardBase/MuiCardBase';
import CardCover from '../MuiCardBase/MuiCardBaseCover';
import CardContent from '../MuiCardBase/MuiCardBaseLong/MuiCardBaseLongContent';
import CardHeader from '../MuiCardBase/MuiCardBaseLong/MuiCardBaseLongHeader';
import CardMetadataWrapper from '../MuiCardBase/MuiCardBaseLong/MuiCardBaseLongMetadataWrapper';
import CardSection from '../MuiCardBase/MuiCardBaseLong/MuiCardBaseLongSection';
import CardTextsWrapper from '../MuiCardBase/MuiCardBaseLong/MuiCardBaseLongTextsWrapper';
import CardTitle from '../MuiCardBase/MuiCardBaseLong/MuiCardBaseLongTitle';
import CardWrapper from '../MuiCardBase/MuiCardBaseLong/MuiCardBaseLongWrapper';
import { type CourseMuiCardProps, PublisherMetadata, ThemeMetadata } from './CourseMuiCard';
import CourseRegistrationStatus from './CourseRegistrationStatus';
import { courseTypeToPresentationNameMap, joinAuthorNames } from './utils';

const CourseMuiLongCard: React.FC<CourseMuiCardProps> = ({
	id,
	contentType,
	publisher,
	index,
	cover,
	title,
	description,
	isPinned,
	isNew,
	itemData,
	course,
	isNewAddMenuButtonMenu,
	onShowNotification,
	isFirstElement,
}) => {
	const { t } = useTranslation();
	const [isExpanded, setIsExpanded] = useState(false);

	const itemLink: string = `/${routes.courseCatalog.root}/${id}`;
	const authorNames = joinAuthorNames(course.authors);

	return (
		<CardWrapper contentType="course" itemLink={itemLink} isNew={isNew} isExpanded={isExpanded}>
			<AddMenuButton
				id={id}
				isPinned={isPinned}
				type={contentType}
				itemData={itemData}
				index={index}
				isNewAddMenuButtonMenu={isNewAddMenuButtonMenu}
				onShowNotification={onShowNotification}
				isFirstElement={isFirstElement}
			/>
			<CardCover
				contentType={contentType}
				itemLink={itemLink}
				cover={cover}
				withPlayIcon
				title={title}
			>
				<CourseRegistrationStatus registrationStatus={course.registrationStatus} />
			</CardCover>
			<CardSection>
				<CardContent>
					<CardHeader
						primaryText={courseTypeToPresentationNameMap[course.type]}
						secondaryText={authorNames}
						enableSecondaryTextTooltip
					/>
					<CardTextsWrapper>
						<CardTitle title={title} itemLink={itemLink} />
						<CardDescription
							description={description}
							isExpanded={isExpanded}
							onShowToggleClick={() => setIsExpanded(!isExpanded)}
						/>
					</CardTextsWrapper>
				</CardContent>
				<CardMetadataWrapper sx={{ flexWrap: 'nowrap' }}>
					<Metadata
						icon="clock"
						sx={{ color: palette.text.secondary, flexShrink: 0 }}
						label={`${course.duration} ${t('Minutes')}`}
					/>
					<ThemeMetadata theme={course.theme} />
					<PublisherMetadata publisher={publisher} />
				</CardMetadataWrapper>
			</CardSection>
		</CardWrapper>
	);
};

export default CourseMuiLongCard;
